const SEPARATORS = /[,;\s]+/;

/** Splits pasted or typed list text into items, dropping empty pieces. */
export function splitChipInput(text: string): string[] {
    return text
        .split(SEPARATORS)
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
}

export function matchesPattern(item: string, pattern: RegExp | undefined): boolean {
    // search() ignores lastIndex, so a pattern with the g or y flag gives the same
    // answer on every call, unlike test().
    return pattern === undefined || item.search(pattern) !== -1;
}

/**
 * Keys each chip by its value and occurrence, so a list that arrives with a duplicate
 * still renders unique keys that do not shift when an earlier chip is removed.
 */
export function chipKeys(values: string[]): string[] {
    const seen = new Map<string, number>();
    return values.map((item) => {
        const occurrence = (seen.get(item) ?? 0) + 1;
        seen.set(item, occurrence);
        return `${item}#${occurrence}`;
    });
}
